import { createUseTranslation } from "core/session/translation";

export const useMaintenancePageTranslation = createUseTranslation({
  en: {
    apiNotAvailableText: "API not available",
    retryText: "Retry",
  },
});
